import React from "react";

import dayjs from "dayjs";

import {CircularProgress, Stack,} from "@mui/joy";

// components
import CommonPaginatedTable from "../../Common/CommonPaginatedTable";
import UserSubscriberContext from "../../../context/UserSubscriberContext";
import BaseApi from "../../../utils/BaseApi";
import CommonCallBackButton from "../../Common/CommonCallBackButton";
import {b64toBlob, downloadBlob} from "../../../utils/misc";
import CertificateCreateModal from "../../Certificate/CertificateCreateModal";
import PaymentCreateModal from "../../Payment/PaymentCreateModal";
import retrievePermission from "../../../utils/retrievePermission";

// icons
import DownloadIcon from "@mui/icons-material/Download";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteIcon from "@mui/icons-material/Delete";
import Snackbar from "@mui/joy/Snackbar";


class PaymentCertificateTab extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            payments: null,
            certificates: null,
            permissions: null,
            phases: null,
            error: null,
            errorOpen: false,
        };
    }

    async componentDidMount() {
        await this.retrievePayments();
        await this.retrieveCertificates();
        await this.retrievePermission();
        await this.retrievePhases();
    }

    async retrievePayments() {
        this.setState(
            {
                payments: null
            }
        );
        const url = 'payment/';
        const api = new BaseApi();
        let params = {
            page_size: 10000,
            opportunity: this.props.opportunity.id,
        }
        let response = await api.get(url, params);
        this.setState(
            {
                payments: response.data.results,
            }
        );
    }

    async retrieveCertificates() {
        this.setState(
            {
                certificates: null
            }
        );
        const url = 'certificate/';
        const api = new BaseApi();
        let params = {
            page_size: 10000,
            opportunity: this.props.opportunity.id,
        }
        let response = await api.get(url, params);
        this.setState(
            {
                certificates: response.data.results,
            }
        );
    }

    async retrievePhases(){
        const api = new BaseApi();
        let url = 'phase'
        let response = await api.get(url, {
            opportunity: this.props.opportunity.id
        });
        let phases = response.data.results
        this.setState({
            phases: phases,
        })
    }

    async retrievePermission() {
        let certificateCreate = await retrievePermission(
            'OppCertViewSet',
            'create',
            this.context.subscriberObject
        );
        let certificateDelete = await retrievePermission(
            'OppCertViewSet',
            'destroy',
            this.context.subscriberObject
        );
        let paymentCreate = await retrievePermission(
            'OppPaymentViewSet',
            'create',
            this.context.subscriberObject
        );
        let paymentDelete = await retrievePermission(
            'OppPaymentViewSet',
            'destroy',
            this.context.subscriberObject
        );

        await this.setState(
            {
                permissions: {
                    certificateCreate: certificateCreate,
                    paymentCreate: paymentCreate,
                    certificateDelete: certificateDelete,
                    paymentDelete: paymentDelete,
                }
            }
        );
    }

    async generate(generateParams, id){
        const api = new BaseApi();
        const url = `certificate/${id}/generate/`;
        let params = {
        }
        if (generateParams[0]){
            params.service = true
        }
        if (generateParams[1]){
            params.download = true
        }
        if (generateParams[2]){
            params.attach = true
        }
        let response = await api.get(url, params);
        if (response.data?.error){
            this.setState(
            {
                    error: response.data.error,
                    errorOpen: true,
                }
            )
        }
        else {
            let timestamp = dayjs().format('YYYYMMDDHHmmss');
            if (params.download){
                downloadBlob(
                    b64toBlob(response.data),
                    `certificate_${id}_${timestamp}.docx`,
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                )
            }
        }
    }

    async deletePayment(id) {
        const url = `payment/${id}/`;
        const api = new BaseApi();
        await api.delete(url);
        await this.retrievePayments()
    }

    async deleteCertificate(id) {
        const url = `certificate/${id}/`;
        const api = new BaseApi();
        await api.delete(url);
        await this.retrieveCertificates()
    }

    render() {
        if (!this.state.certificates || !this.state.payments || !this.state.phases || !this.state.permissions) {
            return (<CircularProgress/>)
        }
        return (
            <Stack>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    color={'warning'}
                    variant={'soft'}
                    open={this.state.errorOpen}
                    onClose={() => (this.setState({errorOpen: false,}))}
                >
                    {this.state.error}
                </Snackbar>
                <CommonPaginatedTable
                    title={'Входящие платежи'}
                    data={this.state.payments}
                    extraComponents={[
                        ...this.state.permissions.paymentCreate?[
                        {
                            component: PaymentCreateModal,
                            componentProps: {
                                opportunity: this.props.opportunity
                            },
                            callBack: this.retrievePayments.bind(this),
                        }
                        ]:[],
                    ]}
                    url={'payment'}
                    fields={[
                        {
                            title: 'Дата',
                            name: 'date',
                            visible: true,
                            preProcess: (value) => (value?dayjs(value).format('DD MMM YYYY'):value),
                            edit: {
                                permission: true,
                                fields: ['date', ],
                                baseUrl: 'payment',
                                callBack: this.retrievePayments.bind(this),
                            },
                        },
                        {
                            title: 'Сумма',
                            name: 'revenue',
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['revenue', ],
                                baseUrl: 'payment',
                                callBack: this.retrievePayments.bind(this),
                            },
                        },
                        {
                            title: 'Подтверждено',
                            name: 'approval',
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['approval', ],
                                baseUrl: 'payment',
                                callBack: this.retrievePayments.bind(this),
                            },
                        },
                        {
                            title: '',
                            visible: this.state.permissions.paymentDelete,
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                icon: DeleteIcon,
                                color: 'danger',
                            },
                            callBack: this.deletePayment.bind(this),
                        },
                    ]}
                />
                <CommonPaginatedTable
                    title={'Акты'}
                    data={this.state.certificates}
                    extraComponents={[
                        ...this.state.permissions.certificateCreate?[
                        {
                            component: CertificateCreateModal,
                            componentProps: {
                                opportunity: this.props.opportunity,
                                phases: this.state.phases,
                            },
                            callBack: this.retrieveCertificates.bind(this),
                        }
                        ]:[],
                    ]}
                    url={'certificate'}
                    fields={[
                        {
                            title: 'Номер',
                            name: 'number',
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['number', ],
                                baseUrl: 'certificate',
                                callBack: this.retrieveCertificates.bind(this),
                            },
                            preProcess: (value) => (value===''?'Не указан':value),
                        },
                        {
                            title: 'Дата',
                            name: 'date',
                            visible: true,
                            preProcess: (value) => (value?dayjs(value).format('DD MMM YYYY'):value),
                            edit: {
                                permission: true,
                                fields: ['date', ],
                                baseUrl: 'certificate',
                                callBack: this.retrieveCertificates.bind(this),
                            },
                        },
                        {
                            title: 'Сумма',
                            name: 'revenue',
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['revenue', ],
                                baseUrl: 'certificate',
                                callBack: this.retrieveCertificates.bind(this),
                            },
                        },
                        {
                            title: 'Подтверждено',
                            name: 'approval',
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['approval', ],
                                baseUrl: 'certificate',
                                callBack: this.retrieveCertificates.bind(this),
                            },
                        },
                        {
                            title: 'Оригиналы',
                            name: 'papers',
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['papers', ],
                                baseUrl: 'certificate',
                                callBack: this.retrieveCertificates.bind(this),
                            },
                        },
                        {
                            title: 'Этап',
                            name: 'phase.title',
                            visible: true,
                            edit: {
                                permission: true,
                                fields: ['phase', ],
                                baseUrl: 'certificate',
                                obj: {
                                    id: 'id',
                                    phase: 'phase.id',
                                },
                                fieldUpdates: [
                                    {
                                        name: 'phase',
                                        updates: [
                                            {
                                                key: 'options',
                                                value: this.state.phases.map((phase) => (
                                                    {
                                                        value: phase.id,
                                                        label: phase.title,
                                                    }
                                                ))
                                            },
                                        ]
                                    }
                                ],
                                callBack: this.retrieveCertificates.bind(this),
                            },
                        },
                        {
                            title: '',
                            visible: true,
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                label: 'Услуги',
                                icon: DownloadIcon,
                                color: 'neutral',
                            },
                            callBack: this.generate.bind(this, [true, true, false]),
                        },
                        {
                            title: '',
                            visible: true,
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                label: 'Услуги',
                                icon: AttachFileIcon,
                                color: 'neutral',
                            },
                            callBack: this.generate.bind(this, [true, false, true]),
                        },
                        {
                            title: '',
                            visible: true,
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                label: 'Работы',
                                icon: DownloadIcon,
                                color: 'neutral',
                            },
                            callBack: this.generate.bind(this, [false, true, false]),
                        },
                        {
                            title: '',
                            visible: true,
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                label: 'Работы',
                                icon: AttachFileIcon,
                                color: 'neutral',
                            },
                            callBack: this.generate.bind(this, [false, false, true]),
                        },
                        {
                            title: '',
                            visible: this.state.permissions.certificateDelete,
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                icon: DeleteIcon,
                                color: 'danger',
                            },
                            callBack: this.deleteCertificate.bind(this),
                        },
                    ]}
                />
            </Stack>
        )
    }
}

export default PaymentCertificateTab
